import axios from 'axios'
import { axiosClient } from '../../clients/axios-client'
import type { FileDownloadUrlResponseDto } from './dtos/file'
import { FileDownloadUrlResponseDtoSchema } from './dtos/file'

export async function getFileDownloadUrl(
  fileId: string
): Promise<FileDownloadUrlResponseDto | null> {
  const trimmedFileId = fileId.trim()
  if (!trimmedFileId) {
    throw new Error('File ID is required')
  }

  const encodedFileId = encodeURIComponent(trimmedFileId)

  try {
    const { data } = await axiosClient.get(`/filepool/files/${encodedFileId}/download-url`)
    return FileDownloadUrlResponseDtoSchema.parse(data)
  } catch (error) {
    if (
      axios.isAxiosError(error) &&
      (error.response?.status === 404 || error.response?.status === 400)
    ) {
      // file not found or bad request, return null as the file is not downloadable
      return null
    }
    throw error
  }
}
